module.exports = __webpack_public_path__ + "static/img/dia.c1dd625.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dia.png
// module id = hUWR
// module chunks = 1